/**
 * CheckoutStepper — 4 horizontal bar segments.
 * Segments 1..currentStep are filled (bg-ink), the rest are gray (bg-divider).
 *
 * Steps:
 *   1 = Rifa selection
 *   2 = Number selection
 *   3 = Buyer details
 *   4 = Payment
 */
export default function CheckoutStepper({ currentStep = 1 }) {
  return (
    <div className='flex gap-1.5 w-full'>
      {[1, 2, 3, 4].map(step => (
        <div
          key={step}
          className={`h-1 flex-1 rounded-full transition-colors ${
            step <= currentStep ? 'bg-ink' : 'bg-divider'
          }`}
        />
      ))}
    </div>
  );
}
